export default __webpack_public_path__ + "61fbf371ca99d9f4dca6d1923d180422.svg";